import { AfterViewInit, OnInit, Component, ElementRef, Renderer2, ViewChild, NgZone, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { Router, ActivatedRoute } from '@angular/router';
import {Channel, LINK_TYPES, LinkService} from '@portals/api';
import { BaseComponent, ResponseService, WindowRef } from '@portals/core';
import { AuthState, ChannelsState, RolesState, UsersState } from '@portals/store';
import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from '@techiediaries/ngx-qrcode';
import { ngxLoadingAnimationTypes } from 'ngx-loading';
import { finalize, tap } from 'rxjs';
import { customAlphabet } from 'nanoid';
import { environment } from '@portals/environments';
import { CookieService } from 'ngx-cookie';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppService } from '@portals/api';
import { ActionDialogComponent, NotificationsResponseComponent } from '@portals/ui';
import { MatDialog } from '@angular/material/dialog';
import * as CryptoJS from 'crypto-js';
import jwt_decode from 'jwt-decode';
import { AnimationOptions } from 'ngx-lottie';
import { AnimationItem } from 'lottie-web';

@Component({
	selector: 'jotto-app-thank-you',
	templateUrl: './thank-you.component.html',
	styleUrls: ['./thank-you.component.scss'],
})
export class ThankYouComponent extends BaseComponent implements AfterViewInit {
	@ViewChild('appContainer', { static: true }) appContainerRef!: ElementRef;
	@ViewChild('lottieButton', { static: true }) lottieButtonRef!: ElementRef;
	@ViewChild('mobileView', { static: true }) mobileViewRef!: ElementRef;
	@ViewChild('channelContent', { static: true })
	channelContentRef!: ElementRef;

	uuid = customAlphabet('1234567890abcdef', 10)();
	uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
	deviceInfo!: any;
	isDesktop: boolean;
	isMobile: boolean;
	isTablet: boolean;
	elementType = NgxQrcodeElementTypes.URL;
	correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
	formLoading = false;
	loaderConfig = {
		animationType: ngxLoadingAnimationTypes.pulse,
		primaryColour: `var(--portals-theme-primary)`,
		secondaryColour: `var(--portals-theme-accent)`,
	};
	channel!: Channel;
	form: FormGroup;
	disabled = true;
	dialogRef: any;
	imageMaxWidth = '720px';
	newFollow = <string>this.cookies.get('follows') ? false : true;
	channelImage = 'assets/images/default.png';
	decryptedParam: any;
	appIcon = 'assets/images/jotto-round.png';
	options: AnimationOptions = {
		path: 'assets/images/lottie/thank-you.json',
		autoplay: true,
		loop: true,
	};
	maxHeight: string = '';
	imageHeight: string = '';

	constructor(private app: AppService, private route: ActivatedRoute, private router: Router, private channelState: ChannelsState, private formBuilder: FormBuilder, public roles: RolesState, private auth: AuthState, private user: UsersState, private cookies: CookieService, private renderer: Renderer2, private deviceService: DeviceDetectorService, protected responseService: ResponseService, private zone: NgZone, public window: WindowRef, public dialog: MatDialog, public linkService : LinkService) {
		super();
		this.form = this.formBuilder.group({
			first_name: [`web-user`],
			last_name: [this.uuid],
			username: [this.uuid],
			password: [this.uuid],
			confirmed: [true],
			blocked: [false],
			role: [1, Validators.required],
			web: [true],
		});
		window.nativeWindow.resizeTo(300, 600);
		this.imageMaxWidth = this.deviceService.getDeviceInfo().deviceType == 'Mobile' ? window.nativeWindow.innerWidth + 'px' : '720px';
		this.isDesktop = this.deviceService.isDesktop();
		this.isMobile = this.deviceService.isMobile();
		this.isTablet = this.deviceService.isTablet();
		const windowHeight = this.isMobile ? window.nativeWindow.innerHeight : 600;
		this.maxHeight = `${windowHeight - 304}px`;
		this.imageHeight = `${((this.isMobile ? 75 : 95) / 100) * (windowHeight - 304)}px`;
		this.channel = this.responseService.currentPage?.parameters.channel as Channel
	}

	ngAfterViewInit() {
		const portrait = window.matchMedia('(orientation: portrait)');
		if (this.isMobile) {
			portrait.matches ? null : this.renderer.setStyle(this.mobileViewRef.nativeElement, 'max-width', '100%');
			this.renderer.setStyle(this.channelContentRef.nativeElement, 'padding', '0px 28px 0px');
			// this.renderer.setStyle(this.channelContentRef.nativeElement, 'max-height', this.maxHeight);
			this.renderer.setStyle(this.appContainerRef.nativeElement, 'background', 'var(--portals-theme-primary)');
			this.renderer.setStyle(this.appContainerRef.nativeElement, 'height', '100vh');
			this.renderer.setStyle(this.appContainerRef.nativeElement, 'max-height', window.innerHeight + 'px');
			this.renderer.setStyle(this.mobileViewRef.nativeElement, 'padding', '20px 0p');
		}

		if (this.isTablet) {
			this.renderer.setStyle(this.mobileViewRef.nativeElement, 'border-radius', '24px');
			this.renderer.setStyle(this.mobileViewRef.nativeElement, 'max-height', '650px');
			this.renderer.setStyle(this.appContainerRef.nativeElement, 'width', '100%');
			if (this.deviceService.device == 'iPhone' && this.deviceService.browser == 'Chrome') {
				this.renderer.setStyle(this.mobileViewRef.nativeElement, 'padding-bottom', '10px');
			}
		}

		if (this.isDesktop) {
			this.renderer.setStyle(this.mobileViewRef.nativeElement, 'max-width', '370px');
			this.renderer.setStyle(this.mobileViewRef.nativeElement, 'min-height', '650px');
		}
	}

	// // Handle the orientationchange event
	// @HostListener('window:orientationchange', ['$event'])
	// handleOrientationChange(event: any) {
	// 	const portrait = window.matchMedia('(orientation: portrait)');
	// 	if (portrait.matches) {
	// 		this.renderer.setStyle(this.mobileViewRef.nativeElement, 'max-width', '100%');
	// 		this.renderer.setStyle(this.mobileViewRef.nativeElement, 'height', window.innerHeight + 'px');
	// 		this.renderer.setStyle(this.appContainerRef.nativeElement, 'height', '100vh');
	// 		this.renderer.setStyle(this.appContainerRef.nativeElement, 'max-width', '-webkit-fill-available');
	// 	} else {
	// 		this.renderer.setStyle(this.mobileViewRef.nativeElement, 'max-width', '100%');
	// 		this.renderer.setStyle(this.mobileViewRef.nativeElement, 'height', '-webkit-fill-available');
	// 		this.renderer.setStyle(this.appContainerRef.nativeElement, 'height', this.deviceService.getDeviceInfo().os == 'iOS' ? '100vh' : '-webkit-fill-available');
	// 		this.renderer.setStyle(this.appContainerRef.nativeElement, 'height', '100vh');
	// 		this.renderer.setStyle(this.appContainerRef.nativeElement, 'max-width', window.innerWidth + 'px');
	// 	}
	// }

	getChannel(uuid: string) {
		this.formLoading = true;
		this.uuidRegex.test(uuid)
			? this.subscribe(
					this.channelState.findOnebyUUID(uuid).pipe(
						tap((data: Channel) => {
							this.channel = data;
						}),
						finalize(() => {
							this.formLoading = false;
						})
					)
			  )
			: this.subscribe(
					this.channelState.findChannelByHash(uuid).pipe(
						tap((data: any) => {
							const normalizedData = this.replaceAttributes(data);
							this.channel = {
								id: normalizedData.id,
								...normalizedData.attributes,
							};
						}),
						finalize(() => {
							this.formLoading = false;
						})
					)
			  );
	}

	replaceAttributes(object: any) {
		let transformedObject: any = {};
		let returnedObject: any = {};
		let counter = 0;
		const keys = Object.keys(object);

		for (const key of keys) {
			if (object.hasOwnProperty(key)) {
				const value = object[key];
				if (typeof value === 'object' && value !== null) {
					if (value.hasOwnProperty('data')) {
						transformedObject[key] = {
							id: object[key].data.id,
							...object[key].data.attributes,
						};
					} else {
						transformedObject[key] = this.replaceAttributes(value);
					}
				} else {
					transformedObject[key] = object[key];
				}
			}

			if (counter === keys.length - 1) {
				returnedObject = { ...transformedObject };
			} else if (counter < keys.length - 1) {
				counter++;
			}
		}

		return returnedObject;
	}

	protected readonly LINK_TYPES = LINK_TYPES;
    protected readonly environment = environment;
}
